import { render, staticRenderFns } from "./budget-event-uo.vue?vue&type=template&id=99a12d4a&scoped=true&"
import script from "./budget-event-uo.vue?vue&type=script&lang=ts&"
export * from "./budget-event-uo.vue?vue&type=script&lang=ts&"
import style0 from "./budget-event-uo.vue?vue&type=style&index=0&id=99a12d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a12d4a",
  null
  
)

export default component.exports